import { FooterHint } from '@pcln/date-picker'
import { themeGet } from '@styled-system/theme-get'
import { Box, Button, Flex, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const BorderBox = styled(Box)`
  border-radius: ${themeGet('borderRadii.full')};
  min-width: 70px;
`

const FooterFlex = styled(Flex)`
  z-index: 1000;
  height: auto;
`

const renderDollarSigns = (n) => Array(n + 2).join('$')

const CustomFooterWithColorCode = ({ dismissCalendar, lowestPrice, showLegend, roundedCorners }) => (
  <FooterFlex
    p={3}
    width={[1]}
    alignItems='center'
    bg='background.lightest'
    borderRadius={roundedCorners ? '2xl' : undefined}
    rounded={roundedCorners ? 'bottom' : undefined}
  >
    <Box mr={3}>
      <FooterHint />
    </Box>
    {lowestPrice && showLegend && (
      <Text color='text.light' fontSize={0}>
        average prices:
      </Text>
    )}
    {lowestPrice &&
      showLegend &&
      [
        { price: `${lowestPrice}+ low`, color: 'pricePrimary' },
        { price: `${lowestPrice + 50}+ avg`, color: 'caution' },
        { price: `${lowestPrice + 100}+ high`, color: 'warning' },
      ].map((priceRange, index) => (
        <BorderBox
          color={`${priceRange.color}.light`}
          mx={1}
          px='12px'
          py='2px'
          key={priceRange.color}
          aria-label={`Price range $${priceRange.price}+`}
          borderRadius='full'
        >
          <Text textAlign='center' fontSize={1}>
            {lowestPrice === Infinity ? renderDollarSigns(index) : `$${priceRange.price}`}
          </Text>
        </BorderBox>
      ))}
    <Button onClick={dismissCalendar} size='medium' aria-label='Done' ml='auto' variation='fill'>
      Done
    </Button>
  </FooterFlex>
)

export default CustomFooterWithColorCode
